import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportCard from "./reportCard";
import { useNavigate } from "react-router-dom";

// Only these 6 reports are shown on this page.
const REPORTS_DATA = [
  { icon: "flash_on", title: "Ignition Trip Report", route: "/Reports/Ignition-trip-reports", category: "fleet" },
  { icon: "pin_drop", title: "Geofence Trip Report", route: "/Reports/Geofence-trip-reports", category: "location" },
  { icon: "pause_circle", title: "Halt Report", route: "/Reports/Halt-reports", category: "trips" },
  { icon: "timeline", title: "Daywise Distance Report", route: "/Reports/Daywise-distance-reports", category: "distance" },
  { icon: "directions_ferry", title: "Boat Trip Report", route: "/Reports/Boat-Report", category: "boat" },
  { icon: "directions_boat", title: "Boat Org Trip Report", route: "/Reports/Boat-org-Report", category: "boat" },
];

const CATEGORY_ORDER = [
  { key: "fleet", label: "Fleet & Vehicle" },
  { key: "location", label: "Location & Geofencing" },
  { key: "trips", label: "Trips, Stops & Routes" },
  { key: "distance", label: "Distance & Attendance" },
  { key: "boat", label: "Boat Reports" },
];

function AllReports() {
  const navigate = useNavigate();

  const groupedSections = CATEGORY_ORDER.map((section) => ({
    ...section,
    reports: REPORTS_DATA.filter((report) => report.category === section.key),
  })).filter((section) => section.reports.length > 0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3}>
        {/* <MDBox pb={2} sx={{ borderBottom: "1px dashed #D8DCE3" }}>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1B2A4A" }}>
            All Reports
          </MDTypography>
        </MDBox> */}

        {groupedSections.map((section, sIndex) => (
          <MDBox key={section.key} mt={sIndex === 0 ? 3 : 4}>
            <MDBox display="flex" alignItems="center" gap={1} mb={2}>
              <MDBox
                sx={{
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "1px solid #C7CCD6",
                  display: "grid",
                  placeItems: "center",
                  fontSize: "0.6rem",
                  fontWeight: 700,
                  color: "#6B7280",
                }}
              >
                {String(sIndex + 1).padStart(2, "0")}
              </MDBox>
              <MDTypography variant="button" fontWeight="bold" sx={{ color: "#1B2A4A", fontSize: "0.85rem" }}>
                {section.label}
              </MDTypography>
            </MDBox>

            <MDBox display="flex" flexWrap="wrap" gap={2}>
              {section.reports.map((report) => (
                <MDBox key={report.route} width="150px" height="105px">
                  <ReportCard
                    icon={report.icon}
                    title={report.title}
                    category={report.category}
                    onClick={() => navigate(report.route)}
                  />
                </MDBox>
              ))}
            </MDBox>
          </MDBox>
        ))}
      </MDBox>
    </DashboardLayout>
  );
}

export default AllReports;